import type { NavigationItem } from "../config/navigation";
import type { AuthUser } from "../context/AuthContext";
import {
  isAuthenticatedPublisher,
  PUBLISHER_AUTH_ENTRY_PATHS,
} from "./authAccess";

type NavigationAccessOptions = {
  benchmarkDesignMode: boolean;
  benchmarkUnlockedPaths: ReadonlySet<string>;
};

export function isNavigationItemUnavailable(
  item: NavigationItem,
  user: AuthUser | null,
  options: NavigationAccessOptions,
): boolean {
  const navUnlocked =
    options.benchmarkDesignMode &&
    options.benchmarkUnlockedPaths.has(item.path);

  if (
    Boolean(item.requiresAuthentication) &&
    !user &&
    !navUnlocked
  ) {
    return true;
  }

  if (
    isAuthenticatedPublisher(user) &&
    PUBLISHER_AUTH_ENTRY_PATHS.has(item.path)
  ) {
    return true;
  }

  return false;
}

export function getNavigationItemByPath(
  items: NavigationItem[],
  path: string,
): NavigationItem | undefined {
  return items.find((item) => item.path === path);
}
